import _ from 'lodash';

import c from 'common/constants/flux-events';
import { serializeForApi } from 'services/resources/ad-preset';

import { browserHistory } from 'react-router';
import AdPresetActions from 'states/resources/ad-presets/actions';

// -----------------
// Edit Ad Preset Form
// -----------------
export const editAdPresetForm = {
    open(adPresetId) {
        return (dispatch, getState) => {
            dispatch({
                type: c.EDIT_AD_PRESET__DRAFT__OPEN,
                payload: {},
            });

            const orgId = _.get(getState(), `profile.ownOrganization.id`, undefined);

            dispatch(AdPresetActions.getOne(orgId, adPresetId, true)).then(
                response => {
                    dispatch({
                        type: c.EDIT_AD_PRESET__DRAFT__INIT,
                        payload: { adpreset: response },
                    });
                },
                error => {
                    dispatch({
                        type: c.EDIT_AD_PRESET__DRAFT__FETCH_FAIL,
                        error: error.body,
                    });
                }
            );
        };
    },

    updateDraft(formData) {
        return {
            type: c.EDIT_AD_PRESET__DRAFT__UPDATE,
            payload: { formData },
        };
    },

    showErrors() {
        return {
            type: c.EDIT_AD_PRESET__DRAFT__SHOW_ERRORS,
            payload: {},
        };
    },

    submitDraft(formData, adPresetId) {
        return async (dispatch, getState) => {
            const sessionEditAdPresetForm = _.get(getState(), `adPresetEdit`, undefined);
            if (!sessionEditAdPresetForm) {
                throw new Error('Store error: session.adPreset does not exist');
            }

            const errors = _.get(sessionEditAdPresetForm, 'errors', []);
            if (errors.length !== 0) {
                // There are errors don't do ajax
                dispatch({
                    type: c.EDIT_AD_PRESET__DRAFT__SHOW_ERRORS,
                    payload: {},
                });
                return;
            }
            //
            // // No errors, essemble payload and serialize
            const draft = _.get(sessionEditAdPresetForm, `draft`, {});
            const payload_beforeSerialized = { ...draft };
            const payloadSerialized = serializeForApi(payload_beforeSerialized, []);

            dispatch({
                type: c.EDIT_AD_PRESET__DRAFT__SUBMIT,
            });

            const orgId = _.get(getState(), `profile.ownOrganization.id`, undefined);

            await dispatch(AdPresetActions.update(orgId, adPresetId, payloadSerialized)).then(
                response => {
                    const adpreset = response;

                    dispatch({
                        type: c.EDIT_AD_PRESET__DRAFT__SUBMIT_SUCCESS,
                        payload: { adpreset },
                    });

                    browserHistory.push(`/ad-preset`);

                    // Tear down
                    dispatch({
                        type: c.EDIT_AD_PRESET__DRAFT__CLOSE,
                    });
                },
                error => {
                    // throw toaster error for server errors

                    dispatch({
                        type: c.EDIT_AD_PRESET__DRAFT__SUBMIT_FAIL,
                        error: error.body,
                    });
                }
            );
            await dispatch(AdPresetActions.getAll(orgId));
        };
    },
    setDefault(adPresetId) {
        return async (dispatch, getState) => {
            const orgId = _.get(getState(), `profile.ownOrganization.id`, undefined);
            const adPreset = _.get(getState(), `resources.adPresets.${adPresetId}.attr`, undefined);
            const { ad_preset_name, ad_preset_properties } = adPreset;
            const payload = { ad_preset_name, ad_preset_properties, is_default_preset: true };

            await dispatch(AdPresetActions.update(orgId, adPresetId, payload)).then(
                response => {
                    const adpreset = response;

                    dispatch({
                        type: c.EDIT_AD_PRESET__DRAFT__SUBMIT_SUCCESS,
                        payload: { adpreset },
                    });
                },
                error => {
                    // throw toaster error for server errors

                    dispatch({
                        type: c.EDIT_AD_PRESET__DRAFT__SUBMIT_FAIL,
                        error: error.body,
                    });
                }
            );

            await dispatch(AdPresetActions.getAll(orgId));
        };
    },

    cancelDraft() {
        browserHistory.push(`/ad-preset`);
        return {
            type: c.EDIT_AD_PRESET__DRAFT__CLOSE,
        };
    },
};
